module.exports = __webpack_public_path__ + "assets/img/push-en.f0b6f46f.jpg";